import { render, staticRenderFns } from "./barcode.vue?vue&type=template&id=64342af2&scoped=true"
import script from "./barcode.vue?vue&type=script&lang=js"
export * from "./barcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64342af2",
  null
  
)

export default component.exports